import { get } from '../../utils/objectHelpers';
import MainComp from '../str-main/component';
export default class {
    onCreate(input) {
        this.reportUrl = get(input, 'containers.[0].cards.[0].video.reportAction.action.URL', '');
    }
    sendTracking(tracking) {
        if (tracking) {
            document.dispatchEvent(new CustomEvent('pulsar', { detail: tracking }));
        }
    }
    navigateToReport(tracking) {
        if (tracking) {
            const event = new CustomEvent('pulsar', { detail: tracking });
            document.dispatchEvent(event);
        }
        if (this.reportUrl) {
            window.open(this.reportUrl, '_blank');
        }
    }
    // This assumes the ajax buttons are for the Category filter.
    // Update if there's another variation.
    fetchCategoryListings(url, evt) {
        MainComp.sendCategoryFilterEvent({
            url: url,
            type: 'marketingBannerType',
            spinnerId: 'marketingBannerLoadingSpinner',
            clickEvent: evt
        });
    }
}
